import React from 'react'
import { getLink } from '@helpers/env'
import { analytics } from '@helpers/analytics'
import { upperFirstLetter } from '@helpers/utils'
import ProductType from '@components/ui/ProductType'
import styles from './styles.module.scss'

type NavigationLinkProps = {
  url: string
  title: string
  isActive: boolean
}
export function NavigationLink({ url, title, isActive }: NavigationLinkProps) {
  return (
    <a
      key={url}
      className={`${styles.nav__link} ${
        isActive ? styles.nav__link_active : ''
      }`}
      href={getLink(`${url}`)} // @TODO: use =internal next link once all collections/products deployed
      onClick={() =>
        analytics('Click', {
          category: 'Secondary Nav',
          label: upperFirstLetter(title)
        })
      }
    >
      <ProductType text={title} />
    </a>
  )
}
